//@ts-check
import axios from 'api/axios'
import { useEffect, useState } from 'react'

/**
 * @module FetchHooks
 */

/**
 * Hook that fetch the my_users_data
 * {@link http://localhost:8000/api/v1/misusuarios}
 * @returns {import('common/types/connections_types').UseFetchHookResponse<LinksDtoArray>}
 */
const useFetchLinks = () => {
  const [response, setResponse] = useState([])
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const fetchData = () => {
    if (loading) {
      return
    }
    setLoading(true)
    axios
      .get('/enlaces')
      .then((/**@type {import('axios').AxiosResponse<LinksDtoArray>}*/ request_response) => {
        const data = request_response.data
        setResponse(data)
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (!loading) fetchData()
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { response, error, loading }
}

export default useFetchLinks
